// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import {
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogProps,
    DialogSurface,
    DialogTitle,
} from '@fluentui/react-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GitHubLogo } from '../../icons/sign-in';
import { useAppStyles } from '../../styles';
import { TrackContext } from '../common';
import { CancelButton, CloseButton, ConfirmButton } from '../dialogs';

// Link GitHub Account dialog properties.
export type LinkGithubDialogProps = Partial<DialogProps> & {
    onConfirm: () => void;
    onClose: () => void;
};

// Link GitHub Account dialog.
export default (props: LinkGithubDialogProps) => {
    const { onConfirm, onClose } = props;
    const styles = useAppStyles();
    return (
        <TrackContext.Provider value={{ container: 'link-github-dialog' }}>
            <Dialog {...props}>
                <DialogSurface>
                    <DialogBody>
                        <DialogTitle action={<CloseButton onClick={onClose} />}>
                            <FormattedMessage
                                defaultMessage="Link your GitHub account"
                                description="Link to GitHub dialog title"
                            />
                        </DialogTitle>
                        <DialogContent className={styles.flexRowCentered}>
                            <GitHubLogo className={styles.dialogImage} />
                            <div className={styles.dialogContent}>
                                <div>
                                    <FormattedMessage
                                        defaultMessage="Course content will be stored in a GitHub repository. In order for us to create the repository, you need to link our GitHub application to your GitHub account."
                                        description="Link to GitHub dialog content"
                                    />
                                </div>
                                <div>
                                    <FormattedMessage
                                        defaultMessage="Click Continue to proceed to GitHub and link your account."
                                        description="Link to GitHub dialog content"
                                    />
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <CancelButton onClick={onClose} />
                            <ConfirmButton onClick={onConfirm}>
                                <FormattedMessage
                                    defaultMessage="Continue to GitHub"
                                    description="Link to GitHub button"
                                />
                            </ConfirmButton>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </TrackContext.Provider>
    );
};
